<template>
  <div>
    <input type="text" class="-input -width-100" v-bind="$props" @focus="onFocus" @blur="onBlur" />
    <div v-if="isFocus"></div>
  </div>
</template>
<script>
export default {
  name: 'g-date-picker',
  props: {
    value: {
      type: String,
      default: ''
    },
    invalid: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      isFocus: false,
      inputValue: this.value
    }
  },
  methods: {
    onFocus () {
      this.isFocus = true
    },
    onBlur () {
      this.isFocus = false
    }
  }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/components/GDatePicker.vue